import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CurrencyComparisonComponent } from './currency-comparison.component';
import { InfoBlockModule } from '@app/core/components/info-block/info-block.module';
import { PipesModule } from '@app/core/pipes/pipes.module';
import { RouterModule } from '@angular/router';

@NgModule({
    declarations: [CurrencyComparisonComponent],
    exports: [CurrencyComparisonComponent],
    imports: [CommonModule, PipesModule, InfoBlockModule, RouterModule]
})
export class CurrencyComparisonModule {}
